import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../helpers/axiosInstance";
interface faqState {
  faqList: [];
  qaUserList: [];
  qaAdminList: [];
  faq: {};
  userQa: "";
  adminQa: "";
  editQa: "";
}

const initialState: faqState = {
  faqList: [],
  qaUserList: [],
  qaAdminList: [],
  faq: {},
  userQa: "",
  adminQa: "",
  editQa: "",
};

const faqSlice = createSlice({
  name: "faq",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(fetchFaq.fulfilled, (state, action) => {
        state.faqList = action.payload;
      })
      .addCase(editFaq.fulfilled, (state, action) => {
        state.faq = action.payload;
      })
      .addCase(addFaq.fulfilled, (state, action) => {
        state.faq = action.payload;
      })
      .addCase(fetchUserQa.fulfilled, (state, action) => {
        state.qaUserList = action.payload;
      })
      .addCase(fetchAdminQa.fulfilled, (state, action) => {
        state.qaAdminList = action.payload;
      })
      .addCase(submitAdminQa.fulfilled, (state, action) => {
        state.adminQa = action.payload;
      })
      .addCase(submitUserQa.fulfilled, (state, action) => {
        state.userQa = action.payload;
      })
      .addCase(editAdminQa.fulfilled, (state, action) => {
        state.editQa = action.payload;
      });
  },
});
//export const {fetchEventList} = homeSlice.actions;
export default faqSlice.reducer;

export const fetchFaq = createAsyncThunk("faqs/getAllFaqs", async () => {
  const response = await axiosInstance.get("api/faqs/getAllFaqs");
  return response.data;
});

export const fetchUserQa = createAsyncThunk(
  "faqAnswer/questionsAskedBy",
  async () => {
    const userId = localStorage.getItem("userId");
    const response = await axiosInstance.get(
      `api/faqAnswer/questionsAskedBy/${userId}`
    );
    return response.data;
  }
);

export const fetchAdminQa = createAsyncThunk("faqAnswer", async () => {
  const response = await axiosInstance.get(`api/faqAnswer`);
  return response.data;
});

export const editFaq = createAsyncThunk("faqs/edit", async (data: any) => {
  const response = await axiosInstance.put(
    `api/faqs/admin/${data.id}`,
    data.payload
  );
  return response.data;
});

export const addFaq = createAsyncThunk("faqs/add", async (data: any) => {
  const response = await axiosInstance.post(`api/faqs/admin/createFaq`, data);
  return response.data;
});

export const submitUserQa = createAsyncThunk(
  "faqAnswer/question",
  async (data: any) => {
    const response = await axiosInstance.post(`api/faqAnswer/question`, data);
    return response.data;
  }
);

export const submitAdminQa = createAsyncThunk(
  "faqAnswer/answer",
  async (data: any) => {
    const response = await axiosInstance.put(`api/faqAnswer/answer`, data);
    return response.data;
  }
);
export const editAdminQa = createAsyncThunk(
  "/faqAnswer/question",
  async (data: any) => {
    const response = await axiosInstance.put(`api/faqAnswer/question`, data);
    return response.data;
  }
);

export const deleteFaq = createAsyncThunk("faqs/delete", async (data: any) => {
  const response = await axiosInstance.delete(`api/faqs/admin/${data.id}`);
  return response.data;
});
